import React from 'react';
import { Switch } from 'antd';
const CustomSwitchButton = ({ ...props }) => {
  return <Switch {...props} />;
};
export default CustomSwitchButton;
